import { render, staticRenderFns } from "./OutletDetails.vue?vue&type=template&id=524a88e2&scoped=true&"
import script from "./OutletDetails.vue?vue&type=script&lang=js&"
export * from "./OutletDetails.vue?vue&type=script&lang=js&"
import style0 from "./OutletDetails.vue?vue&type=style&index=0&id=524a88e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a88e2",
  null
  
)

export default component.exports